// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PanelFoundation-module--overlay--15ECC","relative":"PanelFoundation-module--relative--u_pUq"};